import { Text, Box, Flex } from '@chakra-ui/react';
import _ from 'lodash';
import React, { useState } from 'react';

import { WipConfig } from '../../types';
import { AddButton } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/add/AddButton';
import {
  AddPartyModal,
  getPartyTypeFromPartyKey,
} from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/add/AddPartyModal';
import { CreditAgreement } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/common';
import { PartiesLockButton } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/entity/PartiesLockButton';
import { PartyEntity } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/entity/PartyEntity';

export const PartyEntities: React.FC<{
  parties: CreditAgreement.DomainEntity.Items.BasePartyEntity;
  basePropertyKey: string;
  wipConfig?: WipConfig;
}> = ({ parties, basePropertyKey, wipConfig }) => {
  const [isOpen, setIsOpen] = useState(false);

  const fullPropertyKey = `${basePropertyKey}.parties`;
  return (
    <>
      <Flex alignItems="center" mb="30px">
        <Text fontWeight="bold" fontSize="24px">
          Parties
        </Text>
        {wipConfig?.isMutateAllowed(fullPropertyKey) && (
          <PartiesLockButton
            setArePartiesLocked={wipConfig.setArePartiesLocked}
            arePartiesLocked={wipConfig.arePartiesLocked}
          />
        )}
        {wipConfig?.isMutateAllowed(fullPropertyKey) &&
          !wipConfig.arePartiesLocked && (
            <>
              <AddButton setIsOpen={setIsOpen} />
              <AddPartyModal
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                wipConfig={wipConfig}
                basePropertyKey={fullPropertyKey}
              />
            </>
          )}
      </Flex>
      <Box>
        {_.map(_.toPairs(parties), ([partyKey, partyList]) => {
          if (!partyList.length) return null;

          return (
            <Box key={`${fullPropertyKey}.${partyKey}`}>
              <Text fontWeight="bold" fontSize="18px">
                {_.startCase(partyKey)}
              </Text>
              <Box>
                {
                  // @ts-ignore
                  partyList.map((party, idx) => {
                    return (
                      <PartyEntity
                        key={`${fullPropertyKey}.${partyKey}[${idx.toString()}].${
                          party.entity.id
                        }`}
                        party={party}
                        partyKey={getPartyTypeFromPartyKey(partyKey)}
                        idx={idx}
                        basePropertyKey={`${fullPropertyKey}.${partyKey}`}
                        wipConfig={wipConfig}
                      />
                    );
                  })
                }
              </Box>
            </Box>
          );
        })}
      </Box>
    </>
  );
};
